// extracted by mini-css-extract-plugin
export default {"label":"XeroBillRecord_label__2tqye","required":"XeroBillRecord_required__tJRDH","hint":"XeroBillRecord_hint__RC+HY","suggestion":"XeroBillRecord_suggestion__RTktN"};